import { Component, Input } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterLink } from '@angular/router';
import { IconComponent } from '@app/shared/components/icon/icon.component';
import { GetTextPipe, I18nService } from '@app/shared/utils/i18n.service';
import { faBellConcierge } from '@fortawesome/pro-regular-svg-icons/faBellConcierge';
import { faTruck } from '@fortawesome/pro-regular-svg-icons/faTruck';
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';

/** Product additional info component */
@Component({
	standalone: true,
	selector: 'g-product-additional-info',
	templateUrl: './product-additional-info.component.html',
	styleUrls: ['./product-additional-info.component.scss'],
	imports: [IconComponent, RouterLink, GetTextPipe, FlexLayoutModule],
})
export class ProductAdditionalInfoComponent {
	@Input({ required: true }) readonly product!: api.ProductDto;
	readonly showSupportLink = this.i18n.getCustomFeatureLocale('show_support_link', false);
	readonly supportLink = this.i18n.getCustomFeatureLocale('support_link');
	readonly icons = {
		faCircle,
		faTruck,
		faBellConcierge,
	};

	constructor(private readonly i18n: I18nService) {}
}
